import React from "react";
import colors from "../../utils/colors";

const SIZE_MAP = {
  sm: 16,
  md: 20,
  lg: 22,
  xl: 24,
};

const COLOR_MAP = {
  primary: colors.primary[500],
  primaryLight: colors.primary[300],
  neutral: colors.neutral[600],
  neutralDark: colors.neutral[1000],
  inherit: "currentColor",
};

/**
 * Themed Lucide icon wrapper — consistent size, stroke, and palette tokens.
 */
export default function LayerdIcon({
  icon: Icon,
  size = "lg",
  color = "primary",
  strokeWidth = 2,
  className,
  style,
  "aria-hidden": ariaHidden = true,
  ...rest
}) {
  if (!Icon) return null;

  const pixelSize = typeof size === "number" ? size : SIZE_MAP[size] ?? SIZE_MAP.lg;
  const strokeColor = COLOR_MAP[color] ?? color;

  return (
    <Icon
      size={pixelSize}
      color={strokeColor}
      strokeWidth={strokeWidth}
      className={className}
      style={{ flexShrink: 0, ...style }}
      aria-hidden={ariaHidden}
      {...rest}
    />
  );
}

export { SIZE_MAP, COLOR_MAP };
